import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Hashids from 'hashids'
import {apiPath, serverToken} from "../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";
import TripItem from "../components/TripItem";

function WalletDetails() {

    const navigate = useNavigate();
    const hashids = new Hashids('', 10)

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);

    let {id} = useParams();

    useEffect(() => {

        let decodedID = hashids.decode(id)

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/get-wallet-request/' + decodedID[0], {headers})
            .then(data => {
                setData(data.data);
                setIsLoading(false);
            })

            .catch(error => {
                setIsLoading(false);
            });

    }, []);

    if (!data) {
        return (
            <div className="container mx-auto h-screen flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="container mx-auto h-screen flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }


    const handleWalletApprove = (requestID) => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/approve-wallet-request/' + requestID, {headers})
            .then(data => {
                setIsLoading(false);
                navigate('/admin/billetera');
            })

            .catch(error => {
                setIsLoading(false);
                navigate('/admin/billetera');
            });
    }

    const handleWalletCancel = (requestID) => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/cancel-wallet-request/' + requestID, {headers})
            .then(data => {
                setIsLoading(false);
                navigate('/admin/billetera');
            })

            .catch(error => {
                setIsLoading(false);
                navigate('/admin/billetera');
            });
    }

    return (
        <>
            <div className="flex items-center justify-center py-8 px-4">
                <div className="w-full md:w-1/2 rounded-md shadow-sm py-8 px-5 dark:bg-gray-600 bg-white">

                    <div className="relative flex pb-5 items-center">
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                        <p className="flex-shrink mx-4 text-gray-600 dark:text-gray-100">Detalles de la solicitud</p>
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    </div>

                    <img className="mb-5" src={ "https://cubago.lapincha.app/storage/payments/" + data.wallet_request.payment_image } alt=""/>

                    <p className="text-gray-600 dark:text-gray-100">Información de la compra</p>

                    <div className="grid grid-cols-1">

                        <TripItem
                            icon={
                                <img src={ data.wallet_request.user.avatar !== "null" ? data.wallet_request.user.avatar : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909__340.png" } className="w-full h-full rounded" alt="Payment image"/>
                            }
                            title={"Nombre del cliente"}
                            description={data.wallet_request.user.name}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/>
                                </svg>

                            }
                            title={"Teléfono"}
                            description={data.wallet_request.user.phone !== "empty" ? data.wallet_request.user.phone : "No disponible"}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round"
                                          d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"/>
                                </svg>


                            }
                            title={"Correo"}
                            description={data.wallet_request.user.email}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5"/>
                                </svg>


                            }
                            title={"Código de pago"}
                            description={data.wallet_request.payment_code}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"/>
                                </svg>


                            }
                            title={"Credito comprado"}
                            description={data.wallet_request.payment_balance}
                        />

                    </div>

                    <div className="relative flex pt-5 items-center">
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    </div>

                    <div className="flex justify-end my-5 gap-x-4">
                        <button
                            onClick={() => handleWalletCancel(data.wallet_request.id)}
                            className="px-10 py-2 bg-white border hover:bg-gray-100 text-gray-800 rounded-full">Cancelar
                        </button>
                        <button
                            onClick={() => handleWalletApprove(data.wallet_request.id)}
                            className="px-10 py-2 bg-sky-500 hover:bg-sky-400 text-white rounded-full">Aprobar
                        </button>
                    </div>

                </div>
            </div>
        </>
    );
}

export default WalletDetails;